import { httpDelete, httpGet, httpPatch, httpPost } from '../http.service'

const encoded = (id: string) => encodeURIComponent(id)

class DepartmentService {
	async fetchListing() {
		return await httpGet<any>('api/v1/admin/department')
	}
	async create(params: { name: string; id?: string }) {
		return await httpPost<any>('api/v1/admin/department', params)
	}
	async update(id: string, params: { name?: string }) {
		return await httpPatch<any>(`api/v1/admin/department/${encoded(id)}`, params)
	}
	async delete(id: string) {
		return await httpDelete<any>(`api/v1/admin/department/${encoded(id)}`)
	}
	async detail(id: string) {
		return await httpGet<any>(`api/v1/admin/department/${encoded(id)}`)
	}
}
const departmentService = new DepartmentService()
export { departmentService }
